import React from 'react';

function StoreIntegrationPage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Intégration Store</h1>
      <p>Page `fhc-store-integration.html` convertie en composant React.</p>
    </div>
  );
}

export default StoreIntegrationPage;
